import React from 'react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '@kaa/i18n/customers/keys';

export const ProfileMigrationNotice = () => {
  const { t } = useTranslation();
  const isAfterMigration = new Date() >= new Date('2025-06-17');

  return (
    <div className="vl-u-spacer--small">
      {isAfterMigration ? (
        <>
          <p>{t(i18nKeys.profile.contactMe.afterJune17.text)}
            <a
              href={t(i18nKeys.profile.contactMe.afterJune17.url)}
              target="_blank"
            >
              {t(i18nKeys.profile.contactMe.afterJune17.button)}
            </a>
          </p>
        </>
      ) : (
        <p>{t(i18nKeys.profile.contactMe.beforeJune17)}</p>
      )}
    </div>
  );
};
